const CreateEvent = (event_name, event_detail = {}, element) => {
  let ev = new CustomEvent(event_name, {
    detail: event_detail
  });

  if (element) {
    element.dispatchEvent(ev);
  }
};

export default CreateEvent;